module.exports = __webpack_public_path__ + "static/media/placement.ea611fd6.svg";